import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './PostcardSuccess.css';

const PostcardSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const contactCount = location.state?.contactCount || 0;

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-icon">✅</div>
        <h1>Postcards Sent Successfully!</h1>
        <p>Your postcards have been sent to {contactCount} recipients.</p>
        
        <div className="success-details">
          <div className="detail-item">
            <span className="detail-icon">📮</span>
            <span>Postcards are being processed and will be mailed within 1-2 business days</span>
          </div>
          <div className="detail-item email-item">
            <span className="detail-icon">📧</span>
            <span>You'll receive email confirmation once they're in the mail</span>
          </div>
        </div>

        <div className="success-actions">
          <button 
            onClick={() => navigate('/admin/mail-marketing')}
            className="primary-button"
          >
            Send More Postcards
          </button>
          <button 
            onClick={() => navigate('/admin')}
            className="secondary-button"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostcardSuccess;